/* Domovoi · the shared layer every page loads, built to /assets/site.js.

   Order matters and matches the old script tags: identity first (analytics
   identifies the signed-in person as it loads), then analytics, then the
   pieces that draw on the page. Each module still publishes its window.DV*
   global, because Catered, Curated and Considered call them until they move
   into src/ themselves (D0.3–D0.5). */
import './core/identity.js';
import './core/analytics.js';
import './ui/feedback.js';
import './core/share.js';
import './ui/account-menu.js';
import './ui/site-nav.js';
import './ui/tools-nav.js';
import './ui/offline-note.js';
import './ui/native-links.js';
import { start as startPwa, isInstalled, clearData, installPrompt } from './core/pwa.js';

// Installable web app (D1.1): the service worker, and the cached signed-in
// reads kept to whoever is signed in. window.DVPwa for the pages that need it.
window.DVPwa = { isInstalled, clearData, installPrompt };
startPwa();
